<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="password">Пароль</label>
    <input
      type="password"
      class="form-control"
      id="password"
      placeholder="Введите пароль"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'password-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Password.vue?1cd4b32e